import React, { ChangeEventHandler } from "react";
import { Form } from "react-bootstrap";
import { DropdownFilter } from "../../../../../../components/DropdownFilter";
import { preventTypingNonNumericCharacters } from "../utils";

export type FileSizeType = "B" | "KB" | "MB" | "GB";
const FILE_SIZE_TYPE_OPTIONS: Record<FileSizeType, string> = {
  B: "B",
  KB: "KB",
  MB: "MB",
  GB: "GB"
};
const FILE_SIZE_MENU_OPTIONS = Object.keys(FILE_SIZE_TYPE_OPTIONS).map(key => ({
  label: <span>{FILE_SIZE_TYPE_OPTIONS[key as FileSizeType]}</span>,
  value: key as FileSizeType
}));

interface IFileSizeFieldProps {
  fieldName?: string;
  fileSizeOptionsName?: string;
  inputValue?: number | string;
  selectValue?: FileSizeType;
  placeholder?: string;
  onChangeInput?: ChangeEventHandler<HTMLInputElement>;
  onChangeSelect?: (value: FileSizeType) => void;
  inputFieldErrorMessage?: string;
  testIdKey?: string;
}

const FileSizeField = ({
  fieldName,
  fileSizeOptionsName,
  inputValue,
  selectValue,
  placeholder,
  onChangeInput,
  onChangeSelect,
  inputFieldErrorMessage,
  testIdKey
}: IFileSizeFieldProps) => (
  <div className={"file-size-field-container"}>
    <Form.Control
      type="number"
      step={"any"}
      name={fieldName}
      placeholder={placeholder}
      value={inputValue}
      onChange={onChangeInput}
      className={"file-size-text-field"}
      isInvalid={!!inputFieldErrorMessage}
      data-testid={`${testIdKey}_field_input`}
      onKeyDown={preventTypingNonNumericCharacters}
    />
    <div className={"file-size-type-dropdown-button"}>
      <DropdownFilter
        title={FILE_SIZE_TYPE_OPTIONS.B}
        field={fileSizeOptionsName ?? "fileSizeOptions"}
        menuItems={FILE_SIZE_MENU_OPTIONS}
        activeFilter={selectValue}
        handleFilterChange={onChangeSelect}
        styles={{
          button: {
            minWidth: 0,
            width: "100%",
            border: 0,
            display: "flex",
            fontSize: "14px",
            padding: "0 1.0714285714rem"
          },
          menu: {
            minWidth: 0,
            width: "100%",
            textAlign: "center"
          }
        }}
      />
    </div>
  </div>
);

export default FileSizeField;
